import HttpUtil from "ips/ac/util/HttpUtil";
import Util from "ips/ac/util/Util";
import { AddOrderMappingRequest, OrderMappingEntity } from "ips/ac/model/api/WinDoFlow.api.types";

export default {
  linkOrders(sOrderGuid: string, arMappingEntities: OrderMappingEntity[]): Promise<unknown> {
    const oBody: AddOrderMappingRequest = {
      orderGuid: sOrderGuid,
      mappingEntities: arMappingEntities,
    };
    return HttpUtil.post(this._getServiceUrl() + "/map/orders", null, oBody);
  },

  _getServiceUrl(): string {
    const sBaseUrl = Util.getIpsConfig().getProperty("/RestApi");
    return sBaseUrl + "/order";
  },
};
